import { Dispatch, lazy, SetStateAction, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

import { ContainerButtonPlay } from '../../../../Utils/Button';
import { IEjercicioItems } from '../../../../Interfaces/IMisRutinas';
import VideoPlayer from '../../../../Components/VideoPlayer/VideoPlayer';
import ModalVerticalVideo from '../../../../Components/ModalVerticalVideo/ModalVerticalVideo';

import { grayPlayButton, logoBlanco } from '../../../../Shared/Images';

import '../../../../Shared/css/MisRutinas/reemplazos.css';

const ReemplazoEjercicioDialog = lazy(() => import('../Dialogs/ReemplazoEjercicioDialog'));


interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  ejercicioProp: IEjercicioItems;
  changeRutinas: boolean;
  setChangeRutinas: Dispatch<SetStateAction<boolean>>;
}

function Reemplazos({
  isOpen,
  setIsOpen,
  ejercicioProp,
  changeRutinas,
  setChangeRutinas,
}: Props) {
  const [ejercicioSelected, setEjercicioSelected] = useState<IEjercicioItems>(ejercicioProp)
  const [isReemplazoEjercicioModalOpen, setIsReemplazoEjercicioModalOpen] = useState<boolean>(false);
  const [mostrarVideo, setMostrarVideo] = useState(false);
  const [IsOpenModalVerticalVideo, setIsOpenModalVerticalVideo] = useState<boolean>(false);

  const handleOpenVerticalVideo = (ejercicio : IEjercicioItems) => {
    setEjercicioSelected(ejercicio);
    setIsOpenModalVerticalVideo(true);
  }

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        fullWidth
        className="mremp-dialog"
      >
        {/* ── Header con gradiente dorado ── */}
        <div className="mremp-header">
          <div className="mremp-header-text">
            <span className="mremp-label">Reemplazo</span>
            <h2 className="mremp-title">¿Deseas cambiar de ejercicio?</h2>
          </div>
          <button
            className="mremp-close-btn"
            onClick={() => setIsOpen(false)}
            aria-label="Cerrar"
          >
            ✕
          </button>
        </div>

        {/* ── Contenido ── */}
        <div className="mremp-content">
          <p className="mremp-exercise-name">
            {ejercicioProp?.orden}- {ejercicioProp?.ejercicioReemplazo}
          </p>

          <div
            className="mremp-video-container"
            onClick={() => {
              if (!mostrarVideo) {
                if (ejercicioProp.orientacionReemplazo === 'H') {
                  setMostrarVideo(true);
                } else {
                  handleOpenVerticalVideo(ejercicioProp);
                }
              }
            }}
            style={{ cursor: !mostrarVideo ? 'pointer' : 'default' }}
          >
            {!mostrarVideo ? (
              <>
                {ejercicioProp?.portadaReemplazo != null ? (
                  <img
                    src={ejercicioProp?.portadaReemplazo}
                    alt={ejercicioProp?.ejercicioReemplazo || 'Ejercicio'}
                  />
                ) : (
                  <div className="mremp-fallback-thumb">
                    <img
                      alt="TR4INER"
                      src={logoBlanco}
                    />
                  </div>
                )}
                {/* Play icon minimalista */}
                <div className="mremp-play-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="#fff">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
              </>
            ) : (
              <VideoPlayer
                onEnded={() => setMostrarVideo(false) }
                url={`${ejercicioProp?.ejercicioReemplazoURL}`}
              />
            )}
          </div>
        </div>

        {/* ── Botones de acción ── */}
        <div className="mremp-actions">
          <button
            className="mremp-replace-btn"
            onClick={() => {
              setEjercicioSelected( ejercicioProp )
              setIsReemplazoEjercicioModalOpen(true);
            }}
          >
            Reemplazar
          </button>
          <button
            className="mremp-close-action-btn"
            onClick={() => setIsOpen(false)}
          >
            Cerrar
          </button>
        </div>
      </Dialog>

      {isReemplazoEjercicioModalOpen && (
        <ReemplazoEjercicioDialog
          ejercicio={ ejercicioSelected }
          isOpen={isReemplazoEjercicioModalOpen}
          setIsOpen={setIsReemplazoEjercicioModalOpen}
          setIsModalPadreOpen={setIsOpen}
          changeRutinas={changeRutinas}
          setChangeRutinas={setChangeRutinas}
        />
      )}
      {IsOpenModalVerticalVideo && (
        <ModalVerticalVideo
          isOpen={IsOpenModalVerticalVideo}
          setIsOpen={setIsOpenModalVerticalVideo}
          ejercicio={ejercicioSelected}
          reemplazo
        />
      )}
    </>
  );
}

export default Reemplazos;
